import { render, staticRenderFns } from "./storage-args.vue?vue&type=template&id=2962ae32&scoped=true&"
import script from "./storage-args.vue?vue&type=script&lang=js&"
export * from "./storage-args.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2962ae32",
  null
  
)

export default component.exports